<template>
  <form class="product-checkout-form-buy">
    <h5 class="text-semibold">Formulário de compra</h5>
    <h6 class="text-dark-40 fs-12 mb-4">
      Configure as informações que serão solicitadas ao cliente no formulário
    </h6>

    <snow-checkbox
      v-model="form.request_address_shopper"
      isBoolean
      id="request_address_shopper"
      name="Solicitar endereço do comprador"
    />

    <!-- <div class="form-group">
    <b-form-checkbox v-model="form.request_cpf_cnpj_shopper">
      Solicitar o CPF/CNPJ do comprador
    </b-form-checkbox>
    </div> -->

    <snow-checkbox
      v-model="form.request_phone_shopper"
      isBoolean
      id="request_phone_shopper"
      name="Solicitar telefone do comprador"
    />

    <!-- <div class="form-group">
      <b-form-checkbox v-model="form.coupon_shopper">
        Inserir cupom de desconto
      </b-form-checkbox>
    </div> -->

    <snow-checkbox
      v-model="form.instagram_shopper"
      isBoolean
      id="instagram_shopper"
      name="Solicitar usuário do Instagram do comprador"
      info="(Recomendado para produtos vendidos pelo Instagram)"
    />

    <snow-checkbox
      v-model="form.request_zip_code"
      isBoolean
      id="request_zip_code"
      name="Exigir que o endereço seja preenchido somente com base no CEP"
      warning="(Atenção! Esta opção pode reduzir a sua conversão)"
    />

    <!-- <h6 class="mt-9">Pós-compra</h6>

    <div class="form-group">
      <b-form-checkbox v-model="form.pos_address_shopper">
        Solicitar <strong>endereço</strong> do comprador após a compra caso não
        tenha preenchido
      </b-form-checkbox>
    </div> -->
  </form>
</template>

<script>
import { formFields } from "@/functions/helpers.js";

export default {
  props: {
    optionForm: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      ...formFields(
        [
          "request_address_shopper",
          "request_cpf_cnpj_shopper",
          "request_phone_shopper",
          "coupon_shopper",
          "instagram_shopper",
          "request_zip_code",
          "pos_address_shopper"
        ],
        {
          request_address_shopper: true,
          request_cpf_cnpj_shopper: true,
          request_phone_shopper: true,
          coupon_shopper: false,
          instagram_shopper: false,
          request_zip_code: false,
          pos_address_shopper: false,
          ...(this.optionForm ? this.optionForm : {})
        }
      )
    };
  },
  watch: {
    form: {
      deep: true,
      handler(newVal) {
        this.$emit("update", newVal);
      }
    }
  }
};
</script>
